import TagManager from "react-gtm-module";
const gtmId = "GTM-WF6D34ZK"; // Replace with your GTM ID

export const initializeTagManager = () => {
    TagManager.initialize({ gtmId });
};